import React from 'react'
import Accordion from "../../Accordion/Accordion.js";
import Modal from "../Modal/Modal";
function ElementLesson({ show, element, onClose, onComplete = () => {}}) {
    if (!element) {
        return null
    }
    const data = {
        ...element.resources,
    }
    const accordion =<React.Fragment>
        <Accordion data={data} onComplete={onComplete} />
        </React.Fragment>
     return <Modal
         show={show}
         content={accordion}
         onClose={() => {} }
         showContinue={true}
         continueCaption={ 'Close'}
         onContinueClick={() => {
             if (onClose) {
                 onClose()
             }
         }}
         size={'lg'}/>

}

export default ElementLesson;
